import { Injector, inject, runInInjectionContext } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

/**
 * Carrega um guard sob demanda, mantendo o contexto de injeção.
 *
 * Os guards são a única porta estática do bundle inicial para o AuthService e, por tabela,
 * para o `aws-amplify` (37 KB transferidos). Importados no topo de app.routes.ts, faziam o
 * SDK do Cognito entrar no bundle inicial de toda rota, inclusive das páginas públicas e da
 * landing /oferta, que não têm guard nenhum e nunca autenticam.
 *
 * O `inject(Injector)` precisa acontecer de forma síncrona, antes do await: depois dele o
 * contexto de injeção já não existe, e o `inject(AuthService)` de dentro do guard lançaria.
 * Por isso capturamos o injector aqui e reabrimos o contexto com runInInjectionContext.
 *
 * Os guards carregados assim precisam devolver valor ou Promise (nunca Observable), porque
 * o `.then` abaixo não achata Observable. Os quatro guards do projeto são `async`.
 */
export function lazyGuard(load: () => Promise<CanActivateFn>): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const injector = inject(Injector);
    return load().then((guard) =>
      runInInjectionContext(injector, () => guard(route, state)),
    ) as ReturnType<CanActivateFn>;
  };
}
